import Vue from 'vue';
import router from '../checkout/router/index';
import App from './Checkout.vue';
import { store } from '../checkout/store/store';
import VueSwal from 'vue-swal';
import translateService from '@checkout/i18n/translateService';
require('../checkout/services/filters.js')

Vue.prototype.$i18nApi = translateService
Vue.use(VueSwal)

const root_element = document.getElementById('checkout');
const AppRoot = Vue.extend(App);
new AppRoot({
    el: root_element,
    router,
    store,
    propsData: { ...root_element.dataset }
});
